// Approved educational copy (reviewed by Alphabet Greens).
export const guide = [
  ["what", "What a carbon credit is", [
    "A carbon credit represents one tonne of carbon dioxide equivalent that was avoided or removed from the atmosphere. It is issued by a registry after an independent body has verified the reduction.",
    "Credits are not permits to pollute. They are a way to fund reductions that would not have happened without the finance, while you cut your own emissions.",
  ]],
  ["types", "Avoidance, reduction and removal", [
    "Avoidance and reduction projects stop emissions that would otherwise occur, for example efficient cookstoves that burn less wood. Removal projects take carbon out of the air, for example through trees or soil.",
    "Many buyers hold a mix. Which one fits depends on the claim you want to make and on your budget.",
  ]],
  ["standards", "Standards and registries", [
    "Standards such as Gold Standard and Verra set the rules a project must follow. Registries record each credit with a serial number and show when it is retired.",
    "Ask which standard and methodology a project uses, and check the credit on the public registry yourself.",
  ]],
  ["quality", "Questions to ask any seller", [
    "Is the project additional, meaning it would not have happened without carbon finance? Who verified it, and when? How are emissions reductions measured, with default values or field monitoring?",
    "Is there a risk of double counting? Can I see the registry entry, the vintage and the retirement record for the exact credits I would buy?",
  ]],
  ["price", "What drives price", [
    "Project type, vintage, standard, co-benefits such as health and income, volume and delivery terms all move the price. Cheaper is not always better, and very cheap credits deserve more scrutiny.",
  ]],
  ["process", "How buying works with us", [
    "You book a discovery call. We learn your emissions profile and goals, shortlist projects, share the documents for review, agree volume and price, and then transfer and retire the credits in your name.",
  ]],
  ["claims", "Retirement and what you can claim", [
    "A credit is only used once it is retired on the registry. Claims should be honest about what was done: describe the credits you retired and keep reducing your own emissions.",
  ]],
  ["mistakes", "Common mistakes", [
    "Buying on price alone, skipping registry checks, treating offsets as a substitute for reductions, and making claims that go further than the evidence.",
  ]],
];
